export enum DeedProvenanceAIAnnotationCategory {
  SERVITU = 'SERVITU',
  LIMITAZIONI_PROPRIETA = 'LIMITAZIONI_PROPRIETA',
  VINCOLI_URBANISTICI = 'VINCOLI_URBANISTICI',
  LIMITAZIONI_EDILIZIE = 'LIMITAZIONI_EDILIZIE',
  DIRITTI_TERZI = 'DIRITTI_TERZI',
  ALTRO = 'ALTRO',
}

export enum CadastralSurveyAIAnnotationCategory {
  OWNERSHIP = 'OWNERSHIP',
  CADASTRAL_INFO = 'CADASTRAL_INFO',
  IDENTITY_DOCUMENT = 'IDENTITY_DOCUMENT',
}

const AIAnnotationCategory = {
  ...DeedProvenanceAIAnnotationCategory,
  ...CadastralSurveyAIAnnotationCategory,
};

export type AIAnnotationCategoryType = typeof AIAnnotationCategory[keyof typeof AIAnnotationCategory];

export enum AIAnnotationStructuredDataType {
  CONTACT = 'CONTACT',
  COMPANY = 'COMPANY',
  CADASTRAL_REGISTRY = 'CADASTRAL_REGISTRY',
  IDENTITY_DOCUMENT = 'IDENTITY_DOCUMENT',
}
